import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';

const useAxiosInterceptor = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      async error => {
        if (error.response?.status === 401) {
          try {
            await instance.logoutRedirect({
              postLogoutRedirectUri: window.location.origin
            });
          } catch (logoutError) {
            console.error('Erreur lors de la déconnexion:', logoutError);
          }
          window.location.href = '/';
        }
        else if (error.response?.status === 403) {
          window.location.href = '/';
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [instance]);
};

export default useAxiosInterceptor;